module.exports = __webpack_public_path__ + "static/media/IMG_20170928_210855.1dc46789.jpg";